import React from 'react';
import { rem } from 'polished';
import { Loader } from 'oxyrion-ui/lib';
import PropTypes from 'prop-types';
import Img from 'react-image';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import { translateAvailability, __, formatPrice } from '../../../../Utils';
import { __ } from '../../../../Utils';
// import { catalogDescTranslate, getVariantLabel } from '../../CatalogUtils';
import placeholder from '../Gallery/placeholder-image.png';
import AddToCartWidget from '../../../../Components/AddToCartWidget';
import AlertPopup from '../../../../Components/AlertPopup';

// const AddToCardWrapper = styled.div`
//   height: ${rem(32)};
//   width: ${rem(32)};
//   border: 1px solid #70af00;
//   border-radius: ${rem(2)};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: white;
//   cursor: pointer;
// `;

const Wrapper = styled(Link)`
  width: ${rem(300)};
  height: ${rem(500)};
  padding: ${rem(10)};
  margin: ${rem(10)};
  text-decoration: none;
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  &:hover {
    box-shadow: 0 0 ${rem(8)} ${rem(0)} #70af00;
  }
  cursor: pointer;
  background-image: linear-gradient(to bottom, #ffffff, #ffffff, #f0f0f0);
`;

const ImageWrapper = styled.div`
  padding: ${rem(5)};
  margin-top: ${rem(14)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Name = styled.div`
  margin-bottom: ${rem(6)};
  font-size: ${rem(18)};
  font-weight: bold;
  color: #434245;
`;

const Description = styled.div`
  font-size: ${rem(14)};
  margin-top: ${rem(4)};
  color: #434245;
  font-weight: 300;
`;

const NameAndDescWrapper = styled.div`
  height: ${rem(130)};
  margin-top: ${rem(12)};
  border-bottom: ${rem(1)} solid #70707029;
`;

const Availability = styled.div`
  font-size: ${rem(12)};
  margin-top: ${rem(10)};
  color: #434245;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${rem(5)};
  margin-bottom: ${rem(5)};
  align-items: center;
`;

// const ProductName = styled.div`
//   font-size: 0.75rem;
//   margin-top: ${rem(4)};
//   font-weight: 400;
//   color: #4c4c4c;
// `;

// const VariantsCount = styled.div`
//   font-size: ${rem(14)};
//   font-weight: 200;
//   text-align: end;
//   margin-bottom: ${rem(5)};
//   color: #434245;
// `;

// const Price = styled.div`
//   font-size: ${rem(20)};
//   font-weight: bold;
//   color: #434245;
// `;

// const PiceWrapper = styled.div`
//   height: ${rem(45)};
// `;

const Button = styled.div`
  width: ${rem(165)};
  height: ${rem(45)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${rem(20)};
  font-weight: bold;
  color: white;
  background: #70af00;
  margin-top: ${rem(5)};
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 ${rem(8)} ${rem(0)} #70af00;
  }
`;

// const ImageLoaderWrapper = styled.div`
//   width: ${rem(260)};
//   height: ${rem(240)};
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: absolute;
// `;

const HeightHolder = styled.div`
  height: ${rem(240)};
`;

const Image = styled(Img)`
  max-height: ${rem(230)};
  max-width: ${rem(280)};
  z-index: 2;
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class MarketingMaterialCard extends React.Component {
  state = { addToCart: false, showSuccess: false };

  render() {
    const { data, onProductClick, productLink } = this.props;
    const { addToCart, showSuccess } = this.state;

    return (
      <Wrapper to={productLink}>
        <AlertPopup
          alignUnderHeader
          display={showSuccess}
          text={__('Produkt bol pridaný do objednávky')}
          success
          onClose={() =>
            this.setState({
              showSuccess: false,
            })
          }
          onSubmit={() =>
            this.setState({
              showSuccess: false,
            })
          }
        />

        <AddToCartWidget
          history={this.props.history}
          callback={() => {
            this.setState({
              addToCart: false,
              showSuccess: true,
            });
          }}
          closeCallBack={() =>
            this.setState({
              addToCart: false,
            })
          }
          product={addToCart ? data.product : null}
        />

        <ImageWrapper>
          <Image
            src={[`${baseURL}/images/370x0/${data.image_src}`, placeholder]}
            loader={<Loader color="#70af00" />}
          />
          <HeightHolder />
        </ImageWrapper>
        <NameAndDescWrapper>
          <Name>{data.name}</Name>
          <Description>{data.shortDescription}</Description>
          {/* {data.product && (
            <ProductName>{`${data.product.Description}`}</ProductName>
          )}
          {data.product && data.product.Ean && (
            <ProductName>{`${data.product.Ean}`}</ProductName>
          )} */}
        </NameAndDescWrapper>
        <Availability>
          {`${__('Na sklade:')} ${data.availability}`}
        </Availability>
        <BottomWrapper>
          <Button primary onClick={() => onProductClick(data.id)}>
            {__('DETAIL')}
          </Button>
          {/* <AddToCardWrapper
            onClick={() => {
              this.setState({
                addToCart: true,
              });
            }}
          >
            <Icon name="cart_add" color="#70af00" />
          </AddToCardWrapper> */}
        </BottomWrapper>
      </Wrapper>
    );
  }
}

MarketingMaterialCard.propTypes = {
  onProductClick: PropTypes.func.isRequired,
  data: PropTypes.shape({
    image_src: PropTypes.string,
    name: PropTypes.string,
    shortDescription: PropTypes.string,
    shortDescriptionTranslations: PropTypes.arrayOf,
    availability: PropTypes.string, // available, part-available, not-available
    variants_count: PropTypes.number,
    price_from: PropTypes.shape({
      amount: PropTypes.number,
      currency: PropTypes.string,
    }),
  }).isRequired,
  productLink: PropTypes.string,
  firm: PropTypes.string,
};

MarketingMaterialCard.defaultProps = {
  firm: 'SK',
  productLink: '',
};

export default MarketingMaterialCard;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/MarketingMaterialCard/index.jsx